<template>
  <div>
    <b-modal
      id="modal-recruit-job-posting"
      ref="modal_recruit_job_posting"
      :title="title"
      size="xl"
      modal-class="custom-modal"
      lazy
      centered
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      @hidden="onHidden"
    >
      <b-skeleton-wrapper :loading="isBusy">
        <template #loading>
          <b-form>
            <b-card bg-variant="light">
              <b-row class="mt-2 mb-2">
                <b-col cols="3">
                  <b-skeleton width="21%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col cols="3">
                  <b-skeleton width="53%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="13%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="5%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="35%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="42%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-5">
                <b-col>
                  <b-skeleton width="10%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="109%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="9%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="9%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="5%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
            </b-card>
          </b-form>
        </template>

        <template #default>
          <b-form>
            <b-row>
              <b-col lg="6">
                <b-card class="custom-card">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group id="group-recruit-task-id-select" label="ID заявки на подбор">
                        <recruit-task-select
                          ref="recruit_task_id_select"
                          :is-disabled="selectDisabled || isViewDisabled"
                          :state="getFieldState('recruit_task_id')"
                          :value="newItem.recruit_task_id"
                          @onSelect="onRecruitTaskIdSelect"
                          @onClear="onClearSelected"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group id="group-vacancy" label="Вакансия">
                        <b-form-input
                          type="text"
                          :disabled="isDisabled"
                          v-model="newItem.location_vacancy_name"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-form-group id="group-location" label="Объект">
                    <b-form-input
                      type="text"
                      :disabled="isDisabled"
                      v-model="newItem.location_name"
                    />
                  </b-form-group>
                  <b-form-group id="group-location-address" label="Адрес объекта">
                    <b-form-input
                      type="text"
                      :disabled="isViewDisabled"
                      v-model="newItem.location_address"
                    />
                  </b-form-group>
                  <b-row>
                    <b-col>
                      <b-form-group id="group-opened-date" label="Дата открытия вакансии">
                        <b-form-input
                          type="date"
                          :disabled="isDisabled"
                          v-model.date="newItem.opened_date"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="group-opened-date" label="Дата выхода в смену">
                        <b-form-input
                          type="date"
                          :disabled="isViewDisabled"
                          v-model.date="newItem.closed_date"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-form-group id="group-vacancy-text" label="Текст вакансии">
                    <b-form-textarea
                      type="text"
                      :rows="3"
                      :disabled="isViewDisabled"
                      v-model="newItem.text"
                    />
                  </b-form-group>
                  <b-form-group id="group-organization" label="Организация">
                    <b-form-input
                      type="text"
                      :disabled="isDisabled"
                      v-model="newItem.organization_name"
                    />
                  </b-form-group>
                  <b-form-group id="group-assigned" label="Ответственный">
                    <base-select
                      :is-disabled="isViewDisabled || noLocationDisabled"
                      :options="assignedOptions"
                      :value="newItem.assigned"
                      placeholder="Выберите ответственного"
                      @onSelect="onSelectAssigned"
                    />
                  </b-form-group>
                  <b-form-group id="group-status" label="Статус">
                    <job-posting-status-select
                      :is-disabled="isViewDisabled"
                      :state="getFieldState('status_id')"
                      :value="newItem.status_id"
                      @onSelect="onSelectJobPostingStatus"
                      drop-up
                    />
                  </b-form-group>
                </b-card>
              </b-col>
              <b-col>
                <b-card class="custom-card h-100">
                  <b-form-group id="group-provider-select" label="Сервис">
                    <base-select
                      :is-disabled="isViewDisabled"
                      :options="providerOptions"
                      :value="newItem.provider_id"
                      placeholder="Выберите сервис"
                      @onSelect="onSelectProvider"
                    />
                  </b-form-group>
                  <b-form-group id="group-business-area-select" label="Сфера деятельности">
                    <base-select
                      :is-disabled="isAvitoFieldsDisabled"
                      :options="availableAvitoDictionaries"
                      :value="avitoData.business_area"
                      placeholder="Выберите сферу деятельности"
                      @onSelect="onSelectAvitoBusinessArea"
                    />
                  </b-form-group>
                  <b-form-group id="group-experience-select" label="Опыт работы">
                    <base-select
                      :is-disabled="isAvitoFieldsDisabled"
                      :options="experienceOptions"
                      :value="avitoData.experience"
                      placeholder="Укажите опыт работы"
                      @onSelect="onSelectAvitoExperience"
                    />
                  </b-form-group>
                  <b-form-group id="group-employment-select" label="Занятость">
                    <base-select
                      :is-disabled="isAvitoFieldsDisabled"
                      :options="employmentOptions"
                      :value="avitoData.employment"
                      placeholder="Выберите вид занятости"
                      @onSelect="onSelectAvitoEmployment"
                    />
                  </b-form-group>
                  <b-form-group id="group-schedule-select" label="График">
                    <base-select
                      :is-disabled="isAvitoFieldsDisabled"
                      :options="scheduleOptions"
                      :value="avitoData.schedule"
                      placeholder="Выберите график работы"
                      @onSelect="onSelectAvitoSchedule"
                    />
                  </b-form-group>
                  <b-form-group id="group-avito-location" label="Адрес для Авито">
                    <b-row>
                      <b-col cols="5">
                        <b-form-input
                          placeholder="Город / населённый пункт"
                          v-model.trim="avitoData.location.address.locality"
                          :disabled="isAvitoFieldsDisabled"
                        />
                      </b-col>
                      <b-col cols="5">
                        <b-form-input
                          placeholder="Улица"
                          v-model.trim="avitoData.location.address.street"
                          :disabled="isAvitoFieldsDisabled"
                        />
                      </b-col>
                      <b-col cols="2">
                        <b-form-input
                          placeholder="Дом"
                          v-model.trim="avitoData.location.address.house"
                          :disabled="isAvitoFieldsDisabled"
                        />
                      </b-col>
                    </b-row>
                  </b-form-group>
                  <b-form-group id="group-salary-input" label="Зарплата в месяц, ₽">
                    <b-row class="mb-3">
                      <b-col>
                        <b-form-input
                          type="number"
                          min="0"
                          step="1"
                          placeholder="От"
                          v-model.number="avitoData.salary.from"
                          :disabled="isAvitoFieldsDisabled"
                        />
                      </b-col>
                      <b-col>
                        <b-form-input
                          type="number"
                          min="0"
                          step="1"
                          placeholder="До"
                          v-model.number="avitoData.salary.to"
                          :disabled="isAvitoFieldsDisabled"
                        />
                      </b-col>
                    </b-row>
                    <b-form-group label="Картинка">
                      <b-form-file
                        ref="avitoImgInput"
                        :disabled="isAvitoFieldsDisabled || loading"
                        size="sm"
                        placeholder="Картинка не выбрана"
                        browse-text="Выбрать"
                        accept="image/jpeg,image/png,image/gif,.jpg,.jpeg,.png,.gif"
                        @change="onFileChange"
                      />
                      <div v-if="avitoData.image_url" class="mt-2 d-flex align-items-center">
                        <small class="text-success">
                          <font-awesome-icon icon="check-circle" class="mr-1"/>
                          Изображение загружено
                        </small>
                        <a
                          :href="avitoData.image_url"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="small ml-2"
                        >Открыть</a>
                      </div>
                    </b-form-group>
                  </b-form-group>
                    <div v-if="avitoData.last_error" class="alert alert-danger py-2">
                      <strong>Ошибка Авито:</strong> {{ avitoData.last_error }}
                      <div v-if="avitoStatusText" class="mt-1"><small>{{ avitoStatusText }}</small></div>
                    </div>
                    <div v-else-if="hasAvitoPublication" class="alert alert-info py-2">
                      <strong>Статус Авито:</strong> {{ avitoStatusText }}
                    </div>
                    <div class="w-100 d-flex justify-content-end mt-auto">
                      <div
                        v-if="!hasAvitoIntegration && !loading && newItem.provider_id === 1"
                        class="alert alert-danger m-0 py-1 px-2 mr-2 d-flex align-items-center"
                        style="font-size: 0.85rem; border-style: dashed;"
                      >
                        <font-awesome-icon icon="exclamation-triangle" class="mr-1"/>
                        <span id="orgIntegration">У организации нет интеграции с Авито</span>
                        <b-tooltip target="orgIntegration" title="Укажите ключи интеграции в карточке организации." triggers="hover"/>
                      </div>
                      <b-button
                        v-if="avitoVacancyURL"
                        :href="avitoVacancyURL"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="custom-btn-secondary mr-2"
                      >
                        <font-awesome-icon icon="external-link-alt" class="mr-1"/>
                        Открыть на Авито
                      </b-button>
                      <b-button class="custom-btn-primary" :disabled="loading || isAvitoFieldsDisabled" @click="publishToAvito">
                        <b-spinner v-if="loading" small/>
                        <template v-else>
                          <font-awesome-icon :icon="avitoActionIcon" class="mr-1"/>
                          {{ avitoActionLabel }}
                        </template>
                      </b-button>
                    </div>
                </b-card>
              </b-col>
            </b-row>
          </b-form>
        </template>
      </b-skeleton-wrapper>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button class="custom-btn-secondary mr-2" @click="hideModal">
            Отменить
          </b-button>
          <b-button class="custom-btn-primary" :disabled="loading || isViewDisabled" @click="handleOk">
            <b-spinner v-if="loading" small/>
            Сохранить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import recruitJobPostings from "../../network/recruitJobPostings";
import recruitTasks from "../../network/recruitTasks";
import catalogs from "../../network/catalogs";
import locations from "../../network/locations";
import locationVacancies from "../../network/locationVacancies";
import users from "../../network/users";
import avito from "../../network/avito";
import balansPro from "../../network/balansPro";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import BaseSelect from "../../utilites/commonUi/BaseSelect.vue";
    import RecruitTaskSelect from "./RecruitTaskSelect.vue";
    import JobPostingStatusSelect from "../Catalogs/JobPostingStatuses/JobPostingStatusSelect.vue";

export default {
  name: 'RecruitJobPosting',
  components: { JobPostingStatusSelect, BaseSelect, RecruitTaskSelect },
  mixins: [
    recruitJobPostings, recruitTasks, catalogs, locations, users, locationVacancies, avito, balansPro,
    helpers, dateFormatter
  ],
  data() {
    return {
      title: 'Объявление',
      newItem: this.setNewItem(),
      avitoData: this.setNewAvitoData(),
      locationUsers: [],
      avitoDictionaries: [],
      avitoDictionaryOrganizationId: null,
      isBusy: false,
      loading: false,
      isDisabled: true,
      isViewDisabled: true,
      recruitTaskIdDisabled: false,
      hasAvitoIntegration: false,
      providerOptions: [
        { value: 1, text: 'Авито' },
      ],
      experienceOptions: [
        { value: 'noMatter', text: 'Без опыта' },
        { value: 'moreThan1', text: 'От 1 года' },
        { value: 'moreThan3', text: 'От 3 лет' },
        { value: 'moreThan5', text: 'От 5 лет' },
        { value: 'moreThan10', text: 'От 10 лет' },
      ],
      employmentOptions: [
        { value: 'full', text: 'Постоянная' },
        { value: 'partial', text: 'Частичная' },
        { value: 'temporary', text: 'Временная' },
        { value: 'internship', text: 'Стажировка' },
      ],
      scheduleOptions: [
        { value: 'fixed', text: 'Фиксированный' },
        { value: 'flexible', text: 'Гибкий' },
        { value: 'shift', text: 'Сменный' },
        { value: 'flyInFlyOut', text: 'Вахта' },
      ],
    }
  },
  computed: {
    assignedOptions() {
      if (!this.locationUsers || this.locationUsers.length === 0) return [];

      return this.locationUsers.map(u => ({
        value: u.id,
        text: u.name + ` (${u.role_name})`
      }));
    },
    selectDisabled() {
      return (this.newItem.id > 0) || this.recruitTaskIdDisabled;
    },
    noLocationDisabled() {
      return !this.newItem.location_id;
    },
    isAvitoFieldsDisabled() {
      return this.isViewDisabled || !this.hasAvitoIntegration || Number(this.newItem.provider_id) !== 1;
    },
    hasAvitoPublication() {
      return !!(this.avitoData && (this.avitoData.vacancy_id || this.avitoData.vacancy_uuid));
    },
    isAvitoExternalReady() {
      if (Number(this.newItem.provider_post_id) > 0) return true;
      if (Number(this.avitoData && this.avitoData.vacancy_id) > 0) return true;

      const readyStatuses = ['created', 'activated', 'archived', 'blocked', 'closed', 'expired', 'rejected', 'unblocked'];
      const status = String(this.avitoData && this.avitoData.vacancy_status || '').trim();
      return readyStatuses.includes(status);
    },
    avitoActionLabel() {
      if (!this.hasAvitoPublication) return 'Опубликовать';
      if (this.avitoData.last_error) return 'Повторить публикацию';
      return this.isAvitoExternalReady ? 'Обновить объявление' : 'Проверить статус';
    },
    avitoActionIcon() {
      if (!this.hasAvitoPublication) return 'search-plus';
      if (this.avitoData.last_error) return 'redo';
      return this.isAvitoExternalReady ? 'arrow-alt-circle-up' : 'sync-alt';
    },
    avitoStatusText() {
      const statuses = [
        ['Обработка', this.avitoData && this.avitoData.publication_status],
        ['Вакансия', this.avitoData && this.avitoData.vacancy_status],
        ['Модерация', this.avitoData && this.avitoData.moderation_status]
      ].filter(([, value]) => String(value || '').trim());

      if (!statuses.length) return this.avitoData.last_error ? '' : 'Ожидает обработки Авито';
      return statuses.map(([label, value]) => `${label}: ${value}`).join('; ');
    },
    avitoVacancyURL() {
      const value = String(this.avitoData && this.avitoData.vacancy_url || '').trim();
      if (!value) return '';

      try {
        const url = new URL(value, 'https://www.avito.ru');
        const hostname = url.hostname.toLowerCase();
        const isAvitoHost = hostname === 'avito.ru' || hostname.endsWith('.avito.ru');
        return ['http:', 'https:'].includes(url.protocol) && isAvitoHost ? url.href : '';
      } catch (error) {
        return '';
      }
    },
    availableAvitoDictionaries() {
      const selectedId = this.avitoData && this.avitoData.business_area;

      return this.avitoDictionaries
        .filter(item => !item.deprecated || item.id === selectedId)
        .map(item => ({
          value: item.id,
          text: item.name
        }));
    }
  },
  async mounted() {
    const recruitTaskId = this.$route.params.recruitTaskId;
    this.recruitTaskIdDisabled = this.$route.params.recruitTaskDisabled;
    this.isViewDisabled = this.$route.query.mode === 'view';

    if (recruitTaskId) {
      await this.fillJobPosting(recruitTaskId);
    }
  },
  methods: {
    setNewItem() {
      return {
        id: 0,
        recruit_task_id: null,
        provider_id: 0,
        provider_name: '',
        provider_post_id: null,
        provider_post_uuid: null,
        provider_post_status: '',
        provider_published_date: null,
        assigned: 0,
        status_id: 1,
        status_name: '',
        text: '',
        location_id: 0,
        location_name: '',
        location_address: '',
        location_vacancy_id: 0,
        location_vacancy_name: '',
        opened_date: null,
        closed_date: null,
        organization_id: 0,
        organization_name: '',
      };
    },
    setNewAvitoData() {
      return {
        id: null,
        business_area: null,
        experience: 'noMatter',
        employment: 'full',
        schedule: 'shift',
        location: {
          address: {
            locality: '',
            street: '',
            house: ''
          }
        },
        salary: {
          to: null,
          from: null
        },
        image_url: '',
        vacancy_id: '',
        vacancy_uuid: '',
        vacancy_url: '',
        vacancy_status: '',
        publication_status: '',
        moderation_status: '',
        last_error: '',
        last_synced_at: null
      };
    },
    resetState() {
      this.newItem = this.setNewItem();
      this.avitoData = this.setNewAvitoData();
      this.avitoDictionaries = [];
      this.avitoDictionaryOrganizationId = null;
      this.locationUsers = [];
      this.hasAvitoIntegration = false;
    },
    async showModal(jobPostingId, isView) {
      this.isViewDisabled = isView;
      this.resetState();
      this.$refs.modal_recruit_job_posting.show();

      if (jobPostingId) {
        await this.getJobPosting(jobPostingId);
      }
    },
    hideModal() {
      this.$refs.modal_recruit_job_posting.hide();
    },
    async handleOk() {
      const saved = await this.handleSubmit();
      if (saved) this.hideModal();
    },
    onHidden() {
      this.resetState();
      this.recruitTaskIdDisabled = false;
      this.isViewDisabled = true;
      this.$emit('modal-closed');
    },
    async getJobPosting(jobPostingId) {
      this.isBusy = true;
      this.loading = true;

      const result = await this.getJobPostingById(jobPostingId);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.isBusy = false;
        this.loading = false;
        return;
      }

      this.newItem = { ...this.setNewItem(), ...result.data };
      this.newItem.opened_date = this.formattedFromServerDate(this.newItem.opened_date);
      this.newItem.closed_date = this.formattedFromServerDate(this.newItem.closed_date);
      this.newItem.provider_published_date = this.formattedFromServerDate(this.newItem.provider_published_date);

      await this.getLocationUsersAndOrganization(this.newItem.location_id);
      this.hasAvitoIntegration = await this.checkAvitoIntegration(this.newItem.organization_id);

      if (this.hasAvitoIntegration) {
        await this.getIntegrationDictionaries(this.newItem.organization_id);
        await this.getIntegrationData(this.newItem.id);
      } else {
        this.avitoDictionaries = [];
        this.avitoDictionaryOrganizationId = null;
        this.avitoData = this.setNewAvitoData();
      }

      this.isBusy = false;
      this.loading = false;
    },
    async fillJobPosting(recruitTaskId) {
      this.isBusy = true;
      this.loading = true;
      const result = await this.getRecruitTaskById(recruitTaskId);

      if (result.data) {
        const task = result.data;

        this.newItem.recruit_task_id = task.id;
        this.newItem.location_id = task.location_id;
        this.newItem.location_name = task.location_name;
        this.newItem.location_vacancy_id = task.location_vacancy_id;
        this.newItem.location_vacancy_name = task.location_vacancy_name;
        this.newItem.opened_date = this.formattedFromServerDate(task.opened_date);
        this.newItem.closed_date = this.formattedFromServerDate(task.closed_date);
        this.newItem.provider_published_date = this.formattedFromServerDate(task.provider_published_date);
        this.newItem.assigned = task.assigned;
        this.newItem.text = task.text

        await this.getLocationUsersAndOrganization(task.location_id);
        this.hasAvitoIntegration = await this.checkAvitoIntegration(this.newItem.organization_id);
        if (this.hasAvitoIntegration) {
          await this.getIntegrationDictionaries(this.newItem.organization_id);
        } else {
          this.avitoDictionaries = [];
          this.avitoDictionaryOrganizationId = null;
        }
      }

      this.$refs.modal_recruit_job_posting.show();
      this.isBusy = false;
      this.loading = false;
    },
    async getLocationUsersAndOrganization(locationId) {
      if (!locationId) {
        this.locationUsers = [];
        return;
      }

      const location = await this.getLocationById(locationId);

      if (location && location.data) {
        this.newItem.organization_id = location.data.organization_id;
        this.newItem.organization_name = location.data.organization_name;

        const savedLocationAddress = String(this.newItem.location_address || '').trim();
        this.newItem.location_address = savedLocationAddress || location.data.address || '';
        this.avitoData.location = this.normalizeAvitoLocation(this.newItem.location_address);

        const uniqueUserIds = [...new Set(location.data.location_users.map(item => item.user_id))];
        const promises = uniqueUserIds.map(id => this.getUserById(id));
        const result = await Promise.all(promises);

        this.locationUsers = result.map(res => res.data)
      } else {
        this.locationUsers = [];
      }
    },
    async handleSubmit() {
      if (!this.newItem.recruit_task_id) {
        this.showSubmitError("Выберите заявку на подбор.");
        return;
      }

      if (!this.newItem.status_id) {
        this.showSubmitError("Выберите статус объявления.");
        return;
      }

      if (Number(this.newItem.provider_id) === 1 && this.hasAvitoIntegration) {
        const validationError = this.validateAvitoData(false);
        if (validationError) {
          this.showSubmitError(validationError);
          return false;
        }
      }

      this.loading = true;

      const data = { ...this.newItem };
      data.opened_date = this.formattedToServerDate(data.opened_date);
      data.closed_date = this.formattedToServerDate(data.closed_date);
      data.provider_published_date = this.formattedToServerDate(data.provider_published_date);

      const method = (data.id > 0) ? this.putJobPosting : this.postJobPosting;
      const result = await method(data);

      if (!result || !result.data) {
        this.showError("Не удалось сохранить данные.");
        this.loading = false;
        return false;
      }

      this.newItem.id = result.data.id;

      if (Number(this.newItem.provider_id) === 1 && this.hasAvitoIntegration) {
        const draftSaved = await this.saveAvitoDraft();
        if (!draftSaved) {
          this.loading = false;
          return false;
        }
      }

      this.loading = false;
      this.$emit('refresh');
      return true;
    },
    async onRecruitTaskIdSelect(recruitTaskId) {
      this.newItem.recruit_task_id = recruitTaskId;

      if (recruitTaskId) {
        await this.fillJobPosting(recruitTaskId);
      }
    },
    onClearSelected() {
      this.resetState();
    },
    // Integration
    async checkAvitoIntegration(organizationId) {
      if (!organizationId) return false;

      const result = await this.getOrganizationIntegrations(organizationId);

      if (result && result.data && result.data.id) {
        return result.data.avito_configured === true;
      }

      return false;
    },
    async getIntegrationDictionaries(organizationId) {
      const normalizedOrganizationId = Number(organizationId);
      if (normalizedOrganizationId > 0 && this.avitoDictionaryOrganizationId === normalizedOrganizationId) {
        return;
      }

      const data = {
        organization_id: organizationId,
        dictionary_id: 'business_area'
      }

      const result = await this.getAvitoDictionaries(data);
      this.avitoDictionaries = (result && result.data) ? result.data : [];
      this.avitoDictionaryOrganizationId = result && result.data ? normalizedOrganizationId : null;
    },
    async getIntegrationData(jobPostingId) {
      const result = await this.getJobPostingAvitoIntegration(jobPostingId);

      if (!result || !result.data) {
        if (!result || result.status !== 400) {
          this.showError("Ошибка при получении данных интеграции.");
        }
        this.isBusy = false;
        this.loading = false;
        return;
      }

      const avitoData = result.data;
      const payload = this.parseAvitoPayload(avitoData.payload);
      const salary = this.normalizeAvitoSalary(payload);
      const defaults = this.setNewAvitoData();

      this.avitoData = {
        id: avitoData.id,
        vacancy_id: avitoData.vacancy_id,
        vacancy_uuid: avitoData.vacancy_uuid,
        vacancy_url: avitoData.vacancy_url,
        vacancy_status: avitoData.vacancy_status,
        publication_status: avitoData.publication_status,
        moderation_status: avitoData.moderation_status,
        last_error: avitoData.last_error,
        last_synced_at: avitoData.last_synced_at,

        business_area: this.normalizeBusinessArea(payload.business_area),
        experience: this.normalizeAvitoOption(payload.experience, defaults.experience),
        employment: this.normalizeAvitoOption(payload.employment, defaults.employment),
        schedule: this.normalizeAvitoOption(payload.schedule, defaults.schedule),
        location: this.normalizeAvitoLocation(payload.location || payload.address || this.newItem.location_address),
        salary,
        image_url: payload.image_url || defaults.image_url
      };

      this.isBusy = false;
      this.loading = false;
    },
    parseAvitoPayload(payload) {
      if (!payload) return {};
      if (typeof payload === 'object') return payload;

      try {
        const parsed = JSON.parse(payload);
        return parsed && typeof parsed === 'object' ? parsed : {};
      } catch (error) {
        return {};
      }
    },
    normalizeAvitoOption(value, fallback) {
      if (value && typeof value === 'object') value = value.id;
      return value === null || value === undefined || value === '' ? fallback : value;
    },
    normalizeBusinessArea(value) {
      value = this.normalizeAvitoOption(value, null);
      if (value === null) return null;

      const dictionaryItem = this.avitoDictionaries.find(item => String(item.id) === String(value));
      return dictionaryItem ? dictionaryItem.id : value;
    },
    normalizeAvitoSalary(payload) {
      const currentSalary = payload.salary;
      const legacySalary = payload.salary_range;
      const salary = currentSalary && typeof currentSalary === 'object'
        ? currentSalary
        : (legacySalary && typeof legacySalary === 'object' ? legacySalary : {});

      if (Object.keys(salary).length > 0) {
        return {
          from: this.normalizeNumberValue(salary.from),
          to: this.normalizeNumberValue(salary.to)
        };
      }

      return {
        from: this.normalizeNumberValue(currentSalary),
        to: null
      };
    },
    normalizeNumberValue(value) {
      if (value === null || value === undefined || value === '') return null;
      const normalized = Number(value);
      return Number.isFinite(normalized) ? normalized : null;
    },
    normalizeAvitoLocation(location) {
      if (typeof location === 'string') return this.splitLegacyAvitoLocation(location);
      if (location && typeof location.title === 'string' && !location.address) {
        return this.splitLegacyAvitoLocation(location.title);
      }

      const address = location && typeof location === 'object'
        ? (location.address || location)
        : {};
      return {
        address: {
          locality: String(address.locality || '').trim(),
          street: String(address.street || '').trim(),
          house: String(address.house || '').trim()
        }
      };
    },
    splitLegacyAvitoLocation(location) {
      const value = String(location || '').trim();
      const localityAndStreet = value.split(/\s+ул\.\s+/i);
      const locality = String(localityAndStreet.shift() || '').replace(/^г\.\s*/i, '').trim();
      const streetAndHouse = localityAndStreet.join(' ул. ').split(/,\s*д\.\s*/i);

      return {
        address: {
          locality,
          street: String(streetAndHouse[0] || '').trim(),
          house: String(streetAndHouse[1] || '').trim()
        }
      };
    },
    buildAvitoPayload() {
      const businessArea = this.normalizeNumberValue(this.avitoData.business_area);
      const location = this.normalizeAvitoLocation(this.avitoData.location);
      const address = [
        location.address.locality,
        location.address.street,
        location.address.house
      ].filter(Boolean).join(', ');

      return {
        address,
        title: this.newItem.location_vacancy_name,
        billing_type: 'package',
        business_area: businessArea,
        description: this.stripGenderAndAgeFromText(this.newItem.text),
        employment: this.avitoData.employment,
        experience: this.avitoData.experience,
        schedule: this.avitoData.schedule,
        location,
        salary: {
          from: this.normalizeNumberValue(this.avitoData.salary.from),
          to: this.normalizeNumberValue(this.avitoData.salary.to)
        },
        image_url: this.avitoData.image_url || null
      };
    },
    stripGenderAndAgeFromText(text) {
      return String(text || '')
        .replace(/(?:Пол|Возраст):[^;]*;?/g, '')
        .replace(/\s*;\s*$/g, '')
        .replace(/;\s*;/g, ';')
        .replace(/\s{2,}/g, ' ')
        .trim();
    },
    validateAvitoData(requireRequiredFields) {
      if (requireRequiredFields && !this.avitoData.business_area) {
        return 'Выберите сферу деятельности.';
      }
      if (requireRequiredFields && !this.avitoData.experience) {
        return 'Укажите опыт работы.';
      }
      const location = this.normalizeAvitoLocation(this.avitoData.location);
      if (requireRequiredFields && !location.address.locality) {
        return 'Укажите город или населённый пункт для Авито.';
      }

      const salaryFrom = this.avitoData.salary.from;
      const salaryTo = this.avitoData.salary.to;
      const normalizedFrom = this.normalizeNumberValue(salaryFrom);
      const normalizedTo = this.normalizeNumberValue(salaryTo);
      const hasFrom = salaryFrom !== null && salaryFrom !== undefined && salaryFrom !== '';
      const hasTo = salaryTo !== null && salaryTo !== undefined && salaryTo !== '';

      if (hasFrom && (normalizedFrom === null || normalizedFrom <= 0 || !Number.isInteger(normalizedFrom))) {
        return 'Зарплата «От» должна быть целым положительным числом в рублях за месяц.';
      }
      if (hasTo && (normalizedTo === null || normalizedTo <= 0 || !Number.isInteger(normalizedTo))) {
        return 'Зарплата «До» должна быть целым положительным числом в рублях за месяц.';
      }
      if (hasFrom && hasTo && normalizedFrom > normalizedTo) {
        return 'Зарплата «От» не может быть больше зарплаты «До».';
      }

      return '';
    },
    async saveAvitoDraft() {
      const validationError = this.validateAvitoData(false);
      if (validationError) {
        this.showSubmitError(validationError);
        return false;
      }

      const result = await this.updateJobPostingAvitoDraft(this.newItem.id, {
        payload: this.buildAvitoPayload()
      });

      if (!result || !result.data) {
        this.showError("Объявление сохранено, но не удалось сохранить поля Авито.");
        return false;
      }

      return true;
    },
    async publishToAvito() {
      if (!this.newItem.id) {
        this.showSubmitError("Сначала сохраните объявление, прежде чем публиковать его.");
        return;
      }

      if (this.hasAvitoPublication && !this.isAvitoExternalReady && !this.avitoData.last_error) {
        this.loading = true;
        const refreshed = await this.refreshAvitoStatus();
        this.loading = false;

        if (refreshed && this.isAvitoExternalReady) {
          this.showSuccess("Вакансия создана на Авито и готова к обновлению.");
        } else if (refreshed && !this.avitoData.last_error) {
          this.showSuccess("Авито ещё обрабатывает публикацию.");
        }
        return;
      }

      const validationError = this.validateAvitoData(true);
      if (validationError) {
        this.showSubmitError(validationError);
        return;
      }

      this.loading = true;

      const wrappedData = {
        payload: this.buildAvitoPayload()
      };

      const isUpdate = this.hasAvitoPublication && this.isAvitoExternalReady;
      const method = isUpdate ? this.updateJobPostingAvitoExternal : this.publishJobPostingAvito;
      const result = await method(this.newItem.id, wrappedData);

      if (!result || !result.data) {
        this.showError(this.requestErrorMessage(result, isUpdate ? "Не удалось обновить объявление." : "Не удалось отправить объявление на публикацию."));
        this.loading = false;
        return;
      }

      this.showSuccess(isUpdate ? "Изменения отправлены в Авито." : "Объявление отправлено на публикацию в Авито.");
      await this.reloadJobPostingPublicationState(this.newItem.id);
      this.$emit('refresh');
      this.loading = false;
    },
    async reloadJobPostingPublicationState(jobPostingId) {
      const result = await this.getJobPostingById(jobPostingId);
      if (!result || !result.data) {
        this.showError("Публикация отправлена, но не удалось обновить её локальный статус.");
        return false;
      }

      const publicationFields = [
        'provider_id',
        'provider_name',
        'provider_post_id',
        'provider_post_uuid',
        'provider_post_status',
        'status'
      ];
      publicationFields.forEach(field => {
        this.newItem[field] = result.data[field];
      });
      this.newItem.provider_published_date = this.formattedFromServerDate(result.data.provider_published_date);

      await this.getIntegrationData(jobPostingId);
      return true;
    },
    async refreshAvitoStatus() {
      const result = await this.getJobPostingAvitoExternalStatus(this.newItem.id);
      if (!result || !result.data) {
        this.showError(this.requestErrorMessage(result, "Не удалось проверить статус публикации."));
        return false;
      }

      return await this.reloadJobPostingPublicationState(this.newItem.id);
    },
    requestErrorMessage(result, fallback) {
      if (result && result.error && result.error.message) {
        return result.error.message;
      }
      return fallback;
    },
    async onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
      const maxImageSize = 24 * 1024 * 1024;
      if (!allowedImageTypes.includes(file.type)) {
        this.showError("Допустимы только изображения JPEG, PNG или GIF.");
        return;
      }
      if (file.size > maxImageSize) {
        this.showError("Размер изображения не должен превышать 24 МБ.");
        return;
      }

      if (this.newItem.id === 0) {
        this.showError("Сначала сохраните объявление, прежде чем загружать картинку.");
        return;
      }

      this.loading = true;
      const formData = new FormData();
      formData.append('image', file);
      const result = await this.postJobPostingFile(this.newItem.id, formData);

      if (result.error) {
        this.showError("Ошибка при загрузке изображения");
      } else {
        this.$set(this.avitoData, 'image_url', result.data.url);
        this.showSuccess("Картинка успешно загружена");
      }

      this.loading = false;
    },
    getFieldState(field) {
      const value = this.newItem[field];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'number') {
        return value > 0;
      }

      return !!value;
    },
    onSelectAssigned(assigned) {
      if (assigned) {
        this.$set(this.newItem, 'assigned', assigned.value);
      } else {
        this.$set(this.newItem, 'assigned', null);
      }
    },
    onSelectProvider(provider) {
      if (provider) {
        this.$set(this.newItem, 'provider_id', provider.value);
        this.$set(this.newItem, 'provider_name', provider.text);
      } else {
        this.$set(this.newItem, 'provider_id', null);
        this.$set(this.newItem, 'provider_name', '');
      }
    },
    onSelectJobPostingStatus(status) {
      if (status) {
        this.$set(this.newItem, 'status_id', status.id);
        this.$set(this.newItem, 'status_name', status.name);
      } else {
        this.$set(this.newItem, 'status_id', null);
        this.$set(this.newItem, 'status_name', '');
      }
    },
    onSelectAvitoExperience(experience) {
      if (experience) {
        this.$set(this.avitoData, 'experience', experience.value);
      } else {
        this.$set(this.avitoData, 'experience', 'noMatter');
      }
    },
    onSelectAvitoEmployment(employment) {
      if (employment) {
        this.$set(this.avitoData, 'employment', employment.value);
      } else {
        this.$set(this.avitoData, 'employment', 'full');
      }
    },
    onSelectAvitoSchedule(schedule) {
      if (schedule) {
        this.$set(this.avitoData, 'schedule', schedule.value);
      } else {
        this.$set(this.avitoData, 'schedule', 'shift');
      }
    },
    onSelectAvitoBusinessArea(businessArea) {
      if (businessArea) {
        this.$set(this.avitoData, 'business_area', businessArea.value);
      } else {
        this.$set(this.avitoData, 'business_area', null);
      }
    }
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Recruiting/RecruitJobPosting.vue